<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h3 class="toc-title">Contents</h3></div>
<div class="toc-contents">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/alsobypatriciadixon"><span class="element-title-text">Also by Patricia Dixon</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-foreword has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/foreword"><span class="element-title-text">Foreword</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/nomoreyesterdays"><span class="element-title-text">No More Yesterdays</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/achangeofplan" title="Link target outside of Sample"><span class="element-title-text">A Change of Plan</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/fromthemouthsofbabes" title="Link target outside of Sample"><span class="element-title-text">From the Mouths of Babes</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/achristmastale" title="Link target outside of Sample"><span class="element-title-text">A Christmas Tale</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/acknowledgements" title="Link target outside of Sample"><span class="element-title-text">Acknowledgements</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="element-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/anotefromthepublisher" title="Link target outside of Sample"><span class="element-title-text">A note from the publisher</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/lovewomenscontemporaryfiction" title="Link target outside of Sample"><span class="element-title-text">Love Women’s Contemporary Fiction?</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f80663ca